import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../guards/auth.guard";
import { Roles } from "../../models/person";
import { ChangePasswordFormComponent } from "./components/change-password-form/change-password-form.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { NavbarComponent } from "src/app/components/navbar/navbar.component";

const routes: Routes = [
  {
    path: "configuracoes",
    component: NavbarComponent,
    children: [
      {
        path: "",
        canActivate: [AuthGuard],
        component: SettingsComponent,
        data: {
          role: [Roles.ROLE_ADMIN, Roles.ROLE_SUPERVISOR, Roles.ROLE_MANAGER, Roles.ROLE_USER],
        },
      },
    ],
  },
  // {
  //   path: "redefinir-senha",
  //   component: NavbarComponent,
  //   children: [
  //     {
  //       path: "",
  //       canActivate: [AuthGuard],
  //       component: ChangePasswordFormComponent,
  //       data: {
  //         role: [Roles.ROLE_ADMIN, Roles.ROLE_SUPERVISOR, Roles.ROLE_MANAGER, Roles.ROLE_USER],
  //       },
  //     },
  //   ],
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChangePasswordRoutingModule {}
